import React from 'react';
import classes from './styles.module.css'

const randomAnimation = () => {
    const anims = [
        classes.bounce,
        classes.rubberBand,
        classes.swing,
        classes.jello,
        classes.wobble,
        classes.flip,
        classes.rotateIn,
    ]
    return anims[Math.floor(Math.random() * anims.length)]
}

const Preloader = (props) => {

    const {loading, text} = props
        return loading ? (
            <div className={`${classes.loader}`}>
                <div className={`${classes.loader__image} ${classes.animated} ${randomAnimation()}`}></div>
                <div>{text ? text : "Загрузка..."}</div>
            </div>
        ) : null;
}


export default Preloader